<!--
 * @Description: 
 * @Author: sywang19
 * @LastEditTime: 2022-06-30 10:46:33
 * @LastEditors: sywang19
 * @FilePath: /teaching-web/src/views/SmartEducation/header.vue
-->
<!-- @format -->
<template>
  <!-- <div class="s-header text-white">
    <div class="container">
      <a href="https://www.smartedu.cn" target="_blank">
        <img src="@/assets/img/home/se/header.png" style="width:230px;" />
      </a>
      <i class="line"></i>
      <div class="title">
        <a href="http://www.ah.smartedu.cn" target="_blank">
          <h1>{{ AppInfo.se.title }}</h1>
        </a>
        <p>{{ AppInfo.se.enTitle }}</p>
      </div>
    </div>
  </div> -->
  <div></div>
</template>
<script>
import AppInfo from '@/config/AppInfo';
export default {
  data() {
    return {
      AppInfo
    };
  }
};
</script>
<style lang="less">
.s-header {
  background-color: #5671f3;
  height: 114px;

  .container {
    display: flex;
    align-items: center;
    padding: 24px 0;
  }

  .line {
    margin-left: 18px;
    width: 1px;
    height: 42px;
    background-color: #fff;
  }

  .title {
    padding-left: 18px;

    h1 {
      font-size: 32px;
      line-height: 45px;
      font-weight: 400;
      color: white;
    }
    p {
      font-size: 14px;
      line-height: 20px;
    }
  }
}
</style>
